import { render, staticRenderFns } from "./AdminFraudPrevention.vue?vue&type=template&id=1786f77c&scoped=true"
import script from "./AdminFraudPrevention.vue?vue&type=script&lang=ts"
export * from "./AdminFraudPrevention.vue?vue&type=script&lang=ts"
import style0 from "./AdminFraudPrevention.vue?vue&type=style&index=0&id=1786f77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786f77c",
  null
  
)

export default component.exports